<template>
  <div
    class="page-header header-filter"
    :class="{'cursor-wait': isLoggingIn}"
    filter-color="black"
  >
    <div
      class="page-header-image"
      style="background-image: url(static/img/background/gillwell-background.jpg);"
    />
    <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <ValidationObserver ref="form">
              <form @submit.prevent="validate">
                <card type="login">
                  <h3
                    slot="header"
                    class="header text-center"
                  >
                    Login
                  </h3>
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="email"
                      :error="failed ? 'The Email Address field is required' : null"
                      :has-success="passed"
                      v-model="username"
                      addon-left-icon="nc-icon nc-single-02"
                      :class="{'cursor-wait': isLoggingIn}"
                      placeholder="Email Address..."
                      :disabled="isLoggingIn"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    name="password"
                    rules="required|min:5"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="password"
                      v-model="password"
                      addon-left-icon="nc-icon nc-key-25"
                      placeholder="Password"
                      :class="{'cursor-wait': isLoggingIn}"
                      :error="failed ? 'The Password field is required' : null"
                      :has-success="passed"
                      :disabled="isLoggingIn"
                    />
                  </ValidationProvider>
                  <br>
                  <p-button
                    @click="forgotPassword"
                    native-type="button"
                    slot="footer"
                    size="sm"
                    type="info"
                    outline
                    round
                    block
                    class="mb-3"
                    :class="{'cursor-wait': isLoggingIn}"
                    :disabled="isLoggingIn"
                  >
                    Forgot Password
                  </p-button>
                  <p-button
                    native-type="submit"
                    slot="footer"
                    type="warning"
                    round
                    block
                    class="mb-3"
                    :class="{'cursor-wait': isLoggingIn}"
                    :disabled="isLoggingIn"
                  >
                    Login
                  </p-button>
                </card>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/services/api/user'
import { extend } from 'vee-validate'
import { required, email, min } from 'vee-validate/dist/rules'
import securityService from '@/services/security.js'

extend('email', email)
extend('required', required)
extend('min', min)

export default {
  name: 'Login',
  data: function () {
    return {
      username: null,
      password: null,
      errormessage: null,
      tempHolder: null,
      isLoggingIn: false,
      metaInfo: {
        title: 'Two Beads - Wood Badge Course Management - Login',
        meta: [
          { name: 'description', content: 'Two Beads Wood Badge Course Management Software is designed to assist the Course Director in delivering the Boy Scouts\' advanced workshop for leadership.' }
        ]
      }
    }
  },
  methods: {
    forgotPassword: function () {
      this.$router.push('/forgot-password')
    },
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.login()
        return res
      })
    },
    login: function () {
      this.isLoggingIn = true
      return this.$nextTick(function () {
        return userApi.login(this.username, this.password).then(response => {
          this.tempHolder = response
          if (response.ResultCode !== 'Success') {
            this.$notify({
              message: response.ResultMessage,
              icon: 'ti-icon ti-alert',
              type: 'danger',
              horizontalAlign: 'center',
              timeout: 2000
            })
          } else {
            this.loggedIn(response)
          }
        })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an internal error.  Please try again later.',
              icon: 'ti-icon ti-alert',
              type: 'danger',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .finally(() => {
            this.isLoggingIn = false
          })
      })
    },
    loggedIn: function (userInfo) {
      this.tempHolder = userInfo
      const nextPage = securityService.setupVueSession(this.$root, userInfo)
      this.$router.push(nextPage)
    }
  }
}
</script>
<style scoped>
  .content {
    margin-top: 12%;
  }
  .page-header {
    overflow: hidden;
  }
  .header-filter .container {
    position: relative;
  }
  .cursor-wait {
    cursor: wait !important;
  }
</style>
